import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const Markdown = ({ text }) => (
  <ReactMarkdown rehypePlugins={[rehypeRaw]}>{text}</ReactMarkdown>
);

export default Markdown;
